import React, {PureComponent} from "react"
import styled from "styled-components"

import {StatementItem} from "@irati/types"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import StatusType from "@irati/wallet/types/enums/Status"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import rewardLogo from "@irati-web/reward/src/images/reward.png"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"

import Card from "@irati/ui/src/Layout/Card"
import ExpanderItem from "../ExpanderItem"
import PrimaryDetails from "../PrimaryDetails"
import SecondaryDetails from "../SecondaryDetails/SendCreditAsReward"

const StyledSecondaryDetails = styled(SecondaryDetails)`
  margin-top: 10px;
`

const StyledImg = styled.img`
  width: 130px;
`

const StyledCard = styled(Card)`
  margin-bottom: 20px;
  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);
`

interface Props extends InjectIntl {
  statementItem: StatementItem
  className?: string
  isRewardWallet?: boolean
}

class SendCreditAsReward extends PureComponent<Props> {
  static defaultProps = {
    isRewardWallet: false
  }

  returnSubtitle = () => {
    const {isRewardWallet, statementItem, formatMessage} = this.props
    const {rewardOrder} = statementItem.transfer.sendCreditAsReward
    return isRewardWallet
      ? `
      ${formatMessage({id: "wallet.statementItem.sendCreditAsReward.primaryDetails.rewardWallet.subTitle"})}
      ${firstnameLastname(rewardOrder.recipients.results[0])}
    `
      : `
      ${formatMessage({id: "wallet.statementItem.sendCreditAsReward.primaryDetails.subTitle"})}
      ${firstnameLastname(rewardOrder.createdBy)}
    `
  }

  render() {
    const {statementItem, className, isRewardWallet} = this.props
    const {transfer} = statementItem
    const {amount, sendCreditAsReward, currency} = transfer
    const {rewardOrder} = sendCreditAsReward

    const primaryDetails = {
      image: rewardOrder.reward.thumbnailImage || perkboxLogo,
      title: <StyledImg src={rewardLogo} alt="" />,
      subTitle: this.returnSubtitle(),
      amount,
      currency,
      status: isRewardWallet ? StatusType.SPENT : StatusType.CLEARED
    }

    const secondaryDetails = {
      currency,
      rewardedBy: firstnameLastname(rewardOrder.createdBy),
      transactionAmount: amount
    }

    const idNamespace = id("send-credit-as-reward", this.props)

    if (isRewardWallet) {
      return (
        <StyledCard medium noBorder>
          <PrimaryDetails id={idNamespace} data={primaryDetails} />
        </StyledCard>
      )
    }
    return (
      <ExpanderItem
        className={className}
        id={idNamespace}
        PrimaryElement={() => <PrimaryDetails id={idNamespace} data={primaryDetails} />}
        SecondaryElement={<StyledSecondaryDetails id={idNamespace} data={secondaryDetails} />}
      />
    )
  }
}

export default injectIntl(SendCreditAsReward)
